module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "alt": "image",
      "src": "images/page_ii.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("This Thompson sub-machine-gunner of the Manchester Regiment is on jungle exercises in Malaya in the months leading up to war with Japan. Any jungle training undertaken by the British and Australians in 1941 did not prepare them when encountering the superior field skills of the Japanese Imperial Army. Perhaps the foliage attached to his rather ungainly cork sun helmet as camouflage is symbolic of the difference between the two combatants. It sums up the lack of understanding on the part of the British command of what kind of enemy they were to face a few months later.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c79bc538","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Preface.vue
// module id = 60
// module chunks = 0